'use client';

import { Skeleton } from '@/components/atoms/Skeleton';
import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function FichaPaginaDesktopFallback() {
  return (
    <div>
      {/* BackgroundWrapper */}
      <Skeleton style={{ height: 400, width: '100%', zIndex: -1 }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[7],
          paddingTop: theme.spacing[5],
          paddingBottom: theme.spacing[5],
          paddingLeft: theme.spacing[4],
          paddingRight: theme.spacing[4],
          ...breakpointDesktopDefault,
        }}
      >
        {/* ContainerTopo */}
        {/* <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: '-15%',
            gap: theme.spacing[9],
            width: '100%',
            zIndex: 20,
          }}
        >
          <Skeleton
            style={{
              width: '100vw',
              height: theme.tamanhoCartaz.height['grande'],
            }}
          />
        </div> */}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: theme.spacing[6],
          }}
        >
          {/* BlocoInformacao Sinopse */}
          <Skeleton
            style={{
              width: '70%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
          {/* BlocoInformacao Plataformas */}
          <Skeleton
            style={{
              width: '30%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: theme.spacing[6],
          }}
        >
          {/* BlocoInformacao Elenco */}
          <Skeleton
            style={{
              width: '60%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
          {/* BlocoInformacao Trailer */}
          <Skeleton
            style={{
              width: '40%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
        </div>

        {/* BlocoInformacao Críticas da comunidade */}
        <Skeleton
          style={{
            width: '100%',
            height: 870,
            borderRadius: theme.radius[2],
          }}
        />
      </div>
    </div>
  );
}
